import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const RemoveTextBackgroundIcon = (props: IconProps) => (
  <Icon width="48px" height="48px" viewBox="0 0 48 48" {...props}>
    <path d="M24 12.39C27.06 16.39 30.16 21.25 31.42 24.87L35.88 29.33C35.94 28.79 36 28.23 36 27.67C36 19.71 24 6.07001 24 6.07001C24 6.07001 21.64 8.77001 19 12.45L21.88 15.33C22.56 14.31 23.28 13.33 24 12.39ZM10.82 9.95001L8 12.77L14.64 19.41C13.1 22.33 12 25.25 12 27.67C12 34.29 17.38 39.67 24 39.67C27.04 39.67 29.8 38.53 31.9 36.67L37.16 41.93L40 39.11L10.82 9.95001ZM24 35.67C19.58 35.67 16 32.09 16 27.67C16 26.29 16.64 24.43 17.62 22.39L29.06 33.83C27.66 34.95 25.92 35.67 24 35.67Z" />
  </Icon>
);

export default memo(RemoveTextBackgroundIcon);
